import script from "./cascade.vue?vue&type=script&setup=true&lang=js"
export * from "./cascade.vue?vue&type=script&setup=true&lang=js"

import "./cascade.vue?vue&type=style&index=0&id=36fa458f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36fa458f"]])

export default __exports__